import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import ProductDetailLink from '../../../components/ProductDetailLink';
import useProductUrl from '../../../hooks/useProductUrl';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface CataloguePageListContentItemCardNameProps
  extends StandardDivProps<CataloguePageListContentItemCardNameClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardNameClassKey = 'root';

const themeSettings = { name: 'CataloguePageListContentItemCardName' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListContentItemCardNameClassKey, {}>({
      root: {
        ...theme.typography.h6,
        textAlign: 'left',
        width: '100%',
        maxWidth: '100%',
        fontSize: '0.75rem',
        lineHeight: 1.3,
        overflow: 'hidden',
        '& > a': {
          color: theme.palette.text.primary,
          fontSize: '0.75rem',
          lineHeight: 1.3,
          // Clamp the name so that even extremely long ones cannot reach the price.
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 4,
          overflow: 'hidden',
          overflowWrap: 'anywhere',
        },
      },
    }),
  themeSettings,
);

const CataloguePageListContentItemCardName = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardNameProps
>(({ className, classes: pClasses, product, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const t = useTranslateWithFallback();
  const to = useProductUrl(product);

  return (
    <div ref={ref} className={clsx(classes.root, className)} {...rest}>
      <ProductDetailLink preserveScroll to={to} variant='inherit' noWrap={false}>
        {t(product.name, { acceptString: true })}
      </ProductDetailLink>
    </div>
  );
});

CataloguePageListContentItemCardName.displayName = 'CataloguePageListContentItemCardName';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardName);
